import React, { useEffect, useState } from 'react'
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api'
import { fromAddress, setKey } from 'react-geocode'

function GoogleMapCom({ address }) {
    const [location, setLocation] = useState(null)

    const style = {
        height: '200px',
        maxWidth: '600px',
        width: '100%',
        border: '10px solid #fff',
        margin: '10px 0 0 auto',
    }

    const GOOGLE_API_KEY = 'AIzaSyANJvSnxieaGRhq_Ndt1Fe4MKDkDYE-SOM'

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: GOOGLE_API_KEY,
    })

    useEffect(() => {
        setKey(GOOGLE_API_KEY)

        if (isLoaded && address) {
            fromAddress(address)
                .then(({ results }) => {
                    const { lat, lng } = results[0].geometry.location
                    setLocation({ lat, lng })
                })
                .catch((error) => {
                    console.error('Geocode error:', error)
                })
        }
    }, [isLoaded, address])

    return (
        <>
            {isLoaded && location ? (
                <GoogleMap mapContainerStyle={style} center={location} zoom={19}>
                    <Marker position={location} />
                </GoogleMap>
            ) : (
                <div>Loading map...</div>
            )}
        </>
    )
}

export default GoogleMapCom
